import { Card, Layout, Tag } from "antd";
import styled from "styled-components";
import { COLORS } from "../../../../layout/theme";

export const Page = styled(Layout)`
	height: 100%;
	background: ${COLORS.White};
`;

export const HeaderBar = styled(Layout.Header)`
	background: ${COLORS.White};
	padding: 12px 16px;
	border-bottom: 1px solid ${COLORS.White};
`;

export const Body = styled(Layout)`
	height: 830px;
`;

export const Sider = styled(Layout.Sider)`
	background: ${COLORS.White} !important;
	border-right: 1px solid ${COLORS.White};
	padding: 12px;
	overflow: auto;
`;

export const Content = styled(Layout.Content)`
	padding: 16px 20px;
	overflow: auto;
`;

export const RightCard = styled(Card)`
	border-radius: 16px;
`;

export const PosItem = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
`;

export const KpiCard = styled(Card)`
	border-radius: 16px;
	.ant-statistic-title {
		color: ${COLORS.MediumGrey};
	}
`;

export const Pill = styled(Tag)`
	border-radius: 999px;
	padding: 2px 8px;
`;
